import { FCSelector } from "../../model/form-config.interface";
import { LEGAL_FORM_TYPE } from "../consts/legal-form-type.const";
import { LEGAL_FORM_WRAPPER_ELIGIBILITY } from "../consts/product-capture-field-selectors.consts";

const { options, ...rest } = LEGAL_FORM_TYPE;

export const DB_LEGAL_FORM_TYPE: FCSelector = {
    ...rest,
    options: [
        ...options,
        {
            id: 'WRAPPER',
            label: 'Wrapper eligibility',
            logic: 'EXCLUDE',
            effects: [
                {
                    formControlNames: [LEGAL_FORM_WRAPPER_ELIGIBILITY],
                    hidden: true,
                },
            ],
        }
    ]
}